/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import CSSModules from 'react-css-modules';

import { isDesktop } from '../../utils/mobileHelpers';
import { POST_COMMENTS_ADD } from '../../constants/strings';
import { IDS } from '../../constants/ids';

import Button from '../Button';
import Stats from './Stats';
import styles from './index.styl';

const Footer = ({
  totalComments,
  totalLikes,
  redirect,
  liked,
  likeAction,
  canComment,
  currentUserRole,
  isLoggedIn,
}) => (
  <div styleName="footer">
    <Stats
      {...{ totalComments, totalLikes, liked }}
      commentAction={redirect || null}
      likeAction={likeAction}
      hasActions={!!(isLoggedIn && currentUserRole)}
    />
    <If condition={redirect && canComment && currentUserRole}>
      <Button
        id={IDS.POST.ADD_COMMENT}
        color="accent"
        raised
        type="button"
        onClick={redirect}
        className={!isDesktop() ? 'w-100' : ''}
      >
        <FormattedMessage {...POST_COMMENTS_ADD} />
      </Button>
    </If>
  </div>
);

Footer.propTypes = {
  totalComments: PropTypes.number,
  totalLikes: PropTypes.number,
  redirect: PropTypes.func,
  likeAction: PropTypes.func,
  liked: PropTypes.bool,
  canComment: PropTypes.bool,
  currentUserRole: PropTypes.string,
  isLoggedIn: PropTypes.bool,
};

export default CSSModules(Footer, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/PostPreview/Footer.jsx